import React from 'react';
import TablaCatgProgramaticas from '../components/presupuesto/tablaCategoriasProgramaticas';

function CatgProgramatica() {
  return (
      <div className='col-12 d-flex justify-content-center row'>
        <TablaCatgProgramaticas />
      </div>
  );
}

export default CatgProgramatica;




// WEBPACK FOOTER //
// ./src/pages/categoriaprogramatica.js